export interface CategoryOption {
  value: number;
  label: string;
}

export const GLCodeCategories: CategoryOption[] = [
  { value: 0, label: 'Show All' },
  { value: 1, label: 'Show Active/Inactive' },
  { value: 2, label: 'Show Deleted' },
];

export const MemberCategories: CategoryOption[] = [
  { value: 0, label: 'Show All' },
  { value: 1, label: 'Show Active' },
  { value: 2, label: 'Show Disabled' },
];

export const useGLCodeCategories = () => {
  const categories = [...GLCodeCategories];
  return categories;
};
export const useMemberCategories = () => {
  const categories = [...MemberCategories];
  return categories;
};
